import React from 'react';
import { HStack, Text, Box, Button, Spacer } from '@chakra-ui/react';

interface props {
  GetPageCount: () => number;
  pageMax: number;
  pageNow: number;
  setPageNow: React.Dispatch<React.SetStateAction<number>>;
}

export const NoticeMessageFooter: React.FC<props> = (props) => {
  const { GetPageCount, pageMax, pageNow, setPageNow } = props;

  return (
    <Box mt={9} float='right' gridRow='2/2'>
      <HStack>
        <Spacer />
        <HStack spacing={5}>
          <HStack>
            {pageNow !== 1 && GetPageCount() > pageMax && (
              <>
                <Button
                  bgColor='silver'
                  h={5}
                  fontSize={16}
                  _hover={{ bg: 'transparent' }}
                  onClick={() => setPageNow(1)}
                >
                  {1}
                </Button>
                <Text>..</Text>
              </>
            )}
            {[...new Array(pageMax)].map((_, i) => {
              if (i > GetPageCount() - 1) {
                return;
              }
              if (GetPageCount() < pageMax) {
                return (
                  <Button
                    key={`${'page_' + i}`}
                    bgColor='silver'
                    h={5}
                    fontSize={16}
                    _hover={{ bg: 'transparent' }}
                    onClick={() => setPageNow(i + 1)}
                    disabled={i + 1 === pageNow ? true : false}
                  >
                    {i + 1}
                  </Button>
                );
              }
              if (pageNow < GetPageCount() - (pageMax - 1)) {
                return (
                  <Button
                    key={`${'page_' + i}`}
                    bgColor='silver'
                    h={5}
                    fontSize={16}
                    _hover={{ bg: 'transparent' }}
                    onClick={() => setPageNow(i + pageNow)}
                    disabled={pageNow + i === pageNow ? true : false}
                  >
                    {pageNow + i}
                  </Button>
                );
              } else {
                return (
                  <Button
                    key={`${'page_' + i}`}
                    bgColor='silver'
                    h={5}
                    fontSize={16}
                    _hover={{ bg: 'transparent' }}
                    onClick={() =>
                      setPageNow(GetPageCount() - (pageMax - 1) + i)
                    }
                    disabled={
                      GetPageCount() - (pageMax - 1) + i === pageNow
                        ? true
                        : false
                    }
                  >
                    {GetPageCount() - (pageMax - 1) + i}
                  </Button>
                );
              }
            })}
            {GetPageCount() - (pageNow + pageMax - 1) > 0 && (
              <>
                <Text>..</Text>
                <Button
                  bgColor='silver'
                  h={5}
                  fontSize={16}
                  _hover={{ bg: 'transparent' }}
                  onClick={() => setPageNow(GetPageCount())}
                >
                  {GetPageCount()}
                </Button>
              </>
            )}
          </HStack>
          <HStack>
            <Button
              bgColor='silver'
              h={5}
              fontSize={16}
              _hover={{ bg: 'transparent' }}
              disabled={pageNow <= 1 ? true : false}
              onClick={() => setPageNow(pageNow - 1)}
            >
              {'<'}
            </Button>
            <Button
              bgColor='silver'
              h={5}
              fontSize={16}
              _hover={{ bg: 'transparent' }}
              disabled={pageNow === GetPageCount() ? true : false}
              onClick={() => setPageNow(pageNow + 1)}
            >
              {'>'}
            </Button>
          </HStack>
        </HStack>
      </HStack>
    </Box>
  );
};
